import { URL } from 'common/enums/common/url.enum';
import apiService from './apiService';
var userService = {
    logout: function () { return apiService.POST("".concat(URL.AUTH_URL, "/logoutC"), {}, undefined); },
    refreshToken: function () { return apiService.POST("".concat(URL.AUTH_URL, "/refreshC"), {}, undefined); }
};
export default userService;
